 <ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">

      <ion-title color="secondary" class="ion-text-center header-title">{{ 'REGISTRATION.TITLE' | translate }}</ion-title>

      <ion-buttons slot="start">
        <ion-back-button color="secondary" defaultHref="/" text=""></ion-back-button>
      </ion-buttons>

      <app-top-right color="secondary" slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<!--ion-content>
  <ion-grid>
    <ion-row>

      <ion-col>
        <ion-card>
          
          <ion-card-content>

            <app-social-login></app-social-login>

            <p class="ion-padding ion-text-center">ali</p>

            <app-email-register-form></app-email-register-form>

            <p class="ion-text-center ion-padding">Ste že registrirani? <a [queryParamsHandling]="'preserve'" [routerLink]="['/auth', 'prijava']">Prijavite se.</a></p>
          
          </ion-card-content>
       
        </ion-card>
      </ion-col>
    
    </ion-row>
  </ion-grid>
</ion-content-->

<ion-content>

  <ion-grid>
    <ion-row>
      <ion-col offset-lg="4" offset-md="3" offset-sm="2" size-sm="8" size-md="6" size-lg="4">

        <!--p class="ion-text-center">
            <strong>Pogodba o uporabi storitev Book123.com</strong>
        </p>
        <p align="justify" style="font-size: smaller;">
            Z uporabo storitev Book123.com v mobilni aplikaciji ali spletnem portalu s
            podjetjem PricePilot, d.o.o. sklepate pogodbo o uporabi storitev, ki vam
            omogoča enostavno naročanje na storitve različnih ponudnikov z vnaprejšnjo
            informacijo o najugodnejši ceni željene storitve pri ponudnikih.
        </p>
        <p align="justify" style="font-size: smaller;">
            Z začetkom uporabe potrjujete, da ste se seznanili s <a [routerLink]="['/info', 'splosni-pogoji']">Splošnimi pogoji
            poslovanja</a>, ki so sestavni del pogodbe o uporabi storitev Book123.com in
            jih razumete ter v celoti sprejemate. Podrobnejša določila glede obdelave
            vaših osebnih podatkov, ki nam jih posredujete pri uporabi storitev
            Book123.com, so opredeljena v 5. poglavju Splošnih pogojev. Vaše osebne
            podatke, ki nam jih boste posredovali, bomo obdelovali za namen
            zagotavljanja vaših pravic iz te pogodbe, za preverjanje skladnosti uporabe
            s splošnimi pogoji poslovanja, za analiziranje in proučevanje uporabniških
            navad, za namen ocenjevanja ponudbe, namene predvidevanja vaših interesov,
            ekonomskega položaja in optimiziranja ponudb ter stroškov, za dvig
            zadovoljstva kupcev, pri reševanju vaših vprašanj, pobud, ugovorov ali
            reklamacij, za obveščanje o tehničnih, pravnih in drugih vprašanjih.
            Občasno vas bomo zaprosili za povratne informacije o zadovoljstvu z uporabo
            naše storitve. Podatke bomo obdelovali za namen priprave posebnih ponudb in
            vas o njih obvestil na način, ki ga boste sami izbrali (na e-naslov, sms,
            ali v spletni platformi).
        </p>
        <p align="justify" style="font-size: smaller;">
            Dodatne informacije o vaših pravicah glede varstva osebnih podatkov, si
            lahko preberete tudi v naši Politiki varstva osebnih podatkov objavljeni na
            spletni strani: <a [routerLink]="['/info', 'zasebnost']">Politika zasebnosti</a>
        </p-->

        <app-social-login></app-social-login>


        <div class="ion-padding ion-text-center facebook-not" mode="md">
          <div class="facebook-not__inner">{{ 'REGISTRATION.OR' | translate }}</div>
        </div>

        <app-email-register-form></app-email-register-form>

       
      </ion-col>

    </ion-row>
  </ion-grid>

 
</ion-content>
